import Logo from "../../img/bilaine.svg"
import Dragon from "../../img/dragon.png"
import "./index.scss"
import {Link} from "react-router-dom";
import React, {useEffect, useState} from "react";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Header from "../../components/header";
import Main from "../../components/Main";

const MainPage = () => {
    useEffect(() => {
        document.body.style.overflow = 'hidden'
    }, [])
    ScrollToTop()
    window.addEventListener('resize', () => {
        // получаем текущее значение высоты
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
    let maxHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    return (
        <div className="mainPageContainer" style={{maxHeight: maxHeight}}>
            <Header/>
            <Main/>
        </div>
    );
};

export default MainPage;
